




























import {
  Group
} from '@lx-frontend/cvux'
import { Vue, Component } from 'vue-property-decorator'
import { ActivityCustomerItem } from '@/modules/marketing/activity/types'

@Component({
  filters: {
    Group
  }
})
export default class ActivityRank extends Vue {
  queryForm = {
    page: 1,
    count: 0,
    activity_id: 0
  }

  activityCustomerList: ActivityCustomerItem[] = []

  statistics = {
    total: 0,
    registered: 0
  }

  mounted() {
    const { id = '0' } = this.$route.params
    this.queryForm.activity_id = +id
    this.getData()
  }

  /**
   * 获取用户访问记录
   */
  async getData() {
    const { code, data } = await this.$rest.marketing.getUserViewRecords({ ...this.queryForm })
    if (code === 0) {
      this.activityCustomerList = data.user_view_records || []
      // status已下单=1 待支付=2 报名=3 已收费=4 待审核=5 已审核=6
      this.statistics = {
        total: data.total,
        registered: this.activityCustomerList.filter((item: { status: number }) => item.status >= 3).length
      }
    }
  }

  handleMakeCall (phone: number) {
    window.location.href = 'tel:' + phone
  }
}
